import { useRef, useEffect, useState } from "react";
import Panzoom from "@panzoom/panzoom";
import "./ZomableMap.css";

function ZoomableMap({ leg, imagePath, gpsLink = "", isVisible = false }) {
  const containerRef = useRef(null);
  const panzoomRef = useRef(null);
  const imgRef = useRef(null);

  const [hasRendered, setHasRendered] = useState(false);
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  useEffect(() => {
    if (isVisible && !hasRendered) {
      setHasRendered(true);
    }
  }, [isVisible, hasRendered]);

  useEffect(() => {
    if (!hasRendered || !isImageLoaded || !containerRef.current) return;

    const container = containerRef.current;
    const parent = container.parentElement;

    const zoomToPoint = (panzoom, x, y, scale) => {
      const rect = parent.getBoundingClientRect();
      if (rect.width === 0) return;

      const cx = rect.width / 2;
      const cy = rect.height / 2;

      panzoom.zoom(scale, { animate: false });

      const panX = cx - x * scale;
      const panY = cy - y * scale;

      panzoom.pan(panX, panY, { animate: false, force: true });
    };

    if (panzoomRef.current) return;

    console.log(`Init panzoom for ${leg.title}`);

    const panzoom = Panzoom(container, {
      maxScale: 4,
      minScale: 1,
      contain: "outside",
    });

    panzoomRef.current = panzoom;

    const handleWheel = (e) => {
      panzoom.zoomWithWheel(e);
    };

    parent.addEventListener("wheel", handleWheel, { passive: false });

    requestAnimationFrame(() => {
      zoomToPoint(panzoom, 500, 300, 1.5);
    });

    return () => {
      parent.removeEventListener("wheel", handleWheel);
      panzoom.destroy();
      panzoomRef.current = null;
    };
  }, [hasRendered, isImageLoaded, leg.title]);

  return (
    <div className="map">
      <div className="map-viewport">
        <div ref={containerRef} className="map-inner">
          {hasRendered && (
            <img
              ref={imgRef}
              src={`${process.env.PUBLIC_URL}/images/${imagePath}`}
              alt={`Map for ${leg.title}`}
              onLoad={() => setIsImageLoaded(true)}
            />
          )}
        </div>

        <div className="overlay-label">{leg.title}</div>

        {gpsLink && (
          <a
            href={gpsLink}
            target="_blank"
            rel="noreferrer"
            className="overlay-link"
          >
            Trykk for GPS
          </a>
        )}
      </div>
    </div>
  );
}

export default ZoomableMap;
